import {useRef} from "react";
import {Toast} from "primereact/toast";
import {Tooltip} from "primereact/tooltip";
import SupplyContracts from "./SupplyContracts";

export default function PurchasingProcesses() {
	const toast = useRef(null);
	return (
		<div className="col-12 p-0">
			<SupplyContracts />
			<Tooltip target=".tooltiper" />
			<Toast ref={toast} />
		</div>
	);
}
